import { performanceApi as api } from "./apiClient.tsx";
import { handleApiError } from "./errorHandler.tsx";

export const getSystem = async (): Promise<any> => {
  try {
    const { data } = await api.get("/projects/forms/systems");
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getVoltages = async (system_id: string): Promise<any> => {
  try {
    const { data } = await api.get("/projects/forms/voltages", {
      params: { system_id },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getTechnology = async (voltage_id: string, system_id: string): Promise<any> => {
  try {
    const { data } = await api.get("/projects/forms/technologies", {
      params: { voltage_id, system_id },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getRefrigerant = async (
  technology_id: string,
  system_id: string,
  voltage_id: string
): Promise<any> => {
  try {
    const { data } = await api.get("/projects/forms/refrigerants", {
      params: { technology_id, system_id, voltage_id },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getCapacities = async (
  system_id: string,
  refrigerant_id: string,
  technology_id: string,
  voltage_id: string
): Promise<any> => {
  try {
    const { data } = await api.get("/projects/forms/capacities", {
      params: {
        system_id,
        refrigerant_id,
        technology_id,
        voltage_id,
      },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getHeatExchanger = async (
  system_id: string,
  refrigerant_id: string,
  capacity: string
): Promise<any> => {
  try {
    const { data } = await api.get("/projects/forms/heat-exchangers", {
      params: {
        system_id,
        refrigerant_id,
        capacity,
      },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getEfficiency = async (
  capacity: string,
  system_id: string,
  heat_exchanger_id?: string
): Promise<any> => {
  try {
    const { data } = await api.get("/projects/forms/efficiencies", {
      params: {
        capacity,
        system_id,
        heat_exchanger_id,
      },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getLocations = async (): Promise<any | null> => {
  try {
    const { data } = await api.get("/projects/forms/locations");
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};
